/**
 * 查询表单多选 Select 的标签折叠与 Tooltip 文案；
 * 人员类选择器另见 resolvePeoplePickerMaxTagCount。
 */

export function resolveMaxTagCount(
  pItemType: string | undefined,
  multiple: boolean | undefined,
  maxTagCount: string | number | undefined | null,
): number | 'responsive' | null {
  if (maxTagCount != null && maxTagCount !== '') {
    const parsed = parseInt(String(maxTagCount), 10);
    if (Number.isFinite(parsed)) {
      return parsed;
    }
  }
  if (pItemType === 'xmQueryForm' && multiple === true) {
    return 'responsive';
  }
  return null;
}

/** 人员类选择器：凡多选默认 responsive；有 maxTagCount 则覆盖。 */
export function resolvePeoplePickerMaxTagCount(
  multiple: boolean | undefined,
  maxTagCount: string | number | undefined | null,
): number | 'responsive' | null {
  if (maxTagCount != null && maxTagCount !== '') {
    const parsed = parseInt(String(maxTagCount), 10);
    if (Number.isFinite(parsed)) {
      return parsed;
    }
  }
  if (multiple === true) {
    return 'responsive';
  }
  return null;
}

export function getOmittedTagTooltip(
  omittedValues: Array<{ label?: unknown; value?: unknown }>,
  resolveLabel?: (value: unknown) => string | undefined,
): string {
  return omittedValues
    .map((v) => {
      if (typeof v.label === 'string') {
        return v.label;
      }
      if (resolveLabel != null && v.value !== undefined) {
        const resolved = resolveLabel(v.value);
        if (resolved) {
          return resolved;
        }
      }
      if (v.value != null && v.value !== '') {
        return String(v.value);
      }
      return '';
    })
    .filter(Boolean)
    .join('、');
}
